'use strict';

import React from 'react';
import imgAsync from 'img-async';
import classnames from 'classnames';

var ImagePreviewPlayer = React.createClass({

    displayName: 'ImagePreviewPlayer',

    propTypes: {
        images: React.PropTypes.object.isRequired,
        show:   React.PropTypes.bool,
        poster: React.PropTypes.string
    },

    getInitialState() {
        return {
            previewSlideIdx: null,
            previewSlideUrl: null
        };
    },

    componentWillReceiveProps(nextProps) {
        if (nextProps.show === true) {
            this.showPreviewSlide();
        } else {
            this.stopPreview();
        }
    },

    // Generates a previev slideshow for each video
    showPreviewSlide() {
        var slidesArr = this.props.images;
        var slideIndex = this.state.previewSlideIdx;

        if (slideIndex === (slidesArr.length - 1) || slideIndex === null) {
            slideIndex = 0;
        } else {
            slideIndex = ++slideIndex;
        }

        imgAsync(slidesArr[slideIndex]).then(function() {
            this.tickTimer = window.setTimeout(function() {

                this.setState({
                    previewSlideIdx: slideIndex,
                    previewSlideUrl: slidesArr[slideIndex]
                });

                this.showPreviewSlide();
            }.bind(this), 800);
        }.bind(this));
    },

    // Fallback to the main preview image
    stopPreview() {
        if (this.tickTimer) {
            window.clearTimeout(this.tickTimer);
        }
        this.setState(this.getInitialState());
    },

    // Clear Timeout on unmount
    componentWillUnmount() {
        if (this.tickTimer) {
            window.clearTimeout(this.tickTimer);
        }
    },

    // RENDER
    render() {
        var imageSrc = this.state.previewSlideUrl ? this.state.previewSlideUrl : this.props.poster;
        return (
            <div className={classnames('image__slideshow', {'active': this.props.show})}>
                <img ref="image" src={imageSrc}/>
            </div>
        );
    }
});

module.exports = ImagePreviewPlayer;



// WEBPACK FOOTER //
// ./app/components/thumb/imagePreviewPlayer.jsx